<template>
  <div>
    <DataTable
      ref="DataTable"
      :data-model="'samples'"
      :items="items"
      :loading="loading"
      :display-name-plural="$t('routes.SamplesWaitingForAnalysis')"
      :permission-name="'Samples'"
      :allow-delete="false"
      :allow-create="false"
      :items-per-page="itemsPerPage"
      :exclude-fields="['id', 'customerId', 'hasBarcode']">
      <template #cell(status)="row">
        {{ $t('samples.Status.'+row.item.status) }}
      </template>
      <template #extraTableActions>
        <b-button
          class="ml-2"
          variant="primary"
          @click="$refs.sendModal.show();"
          v-if="$auth.check(
            'Permissions.AdminPanel.Samples.Edit'
          )">
          Odeslat všechny do analýzy
        </b-button>
        <b-button
          class="ml-2"
          variant="primary"
          @click="$refs.scanModal.show(); $barcodeScanner.init(scanBarcode)"
          v-if="$auth.check(
            'Permissions.AdminPanel.Samples.Edit'
          )">
          Scanovat kód a odeslat do analýzy
        </b-button>
      </template>
    </DataTable>
    <b-modal id="modal-center"
             ref="sendModal"
             centered
             :static="true">
      <template #modal-header>
        <div class="d-flex justify-content-center w-100 text-center">
          <h3>
            Jste si jisti, že chcete poslat všechny vzorky k analýze?
          </h3>
        </div>
      </template>
      <template #modal-footer="{ cancel, ok }">
        <b-button
          variant="success"
          @click="sendToAnalysis();">
          Odeslat
        </b-button>
        <b-button
          variant="danger"
          @click="$refs.sendModal.hide();">
          {{ $t('common.Cancel') }}
        </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-center"
             ref="scanModal"
             centered
             :static="true">
      <template #modal-header>
        <div class="d-flex justify-content-center w-100 text-center">
          <h3>
            {{ $t('common.ScanBarcode') }}
          </h3>
        </div>
      </template>
      <template #modal-footer="{ cancel, ok }">
        <b-button
          variant="danger"
          @click="$refs.scanModal.hide(); $barcodeScanner.destroy()">
          {{ $t('common.Cancel') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import DataTable from '@components/admin/DataTable';

export default {
  components: {
    DataTable
  },
  data() {
    return {
      items: [],
      loading: true
    };
  },
  props: {
    itemsPerPage: {
      type: Number,
      required: false,
      default: 10
    }
  },
  created() {
    this.reload();
  },
  methods: {
    reload() {
      this.loading = true;
      this.axios.get('/admin/samples/waitingforanalysis')
        .then((res) => {
          if (res.status === 200 && res.data.result.length > 0) {
            this.items = res.data.result;
          } else {
            this.items = [];
          }
          this.loading = false;
        }).catch((err) => Promise.reject(err))
        .finally(() => {
          this.$refs.DataTable.finishSpinner();
        });
    },
    sendToAnalysis() {
      this.axios.post('/admin/samples/sendalltoanalysis')
        .then((res) => {
          if (res.status === 204) {
            this.reload();
            this.$root.$bvToast.toast('Vzorky úspěšne odeslány do analýzy', {
              title: 'Úspěšne odesláno',
              variant: 'success',
              toaster: 'b-toaster-top-right'
            });
            this.$refs.sendModal.hide();
          }
        }).catch(() => {
          this.$root.$bvToast.toast('Vzorky se nepodařilo odeslat', {
            title: 'Nepodařilo se odeslat',
            variant: 'danger',
            toaster: 'b-toaster-top-right'
          });
          this.$refs.sendModal.hide();
        });
    },
    scanBarcode(code) {
      this.axios.post('admin/samples/sendtoanalysis', {
        Barcode: code
      }).then((response) => {
        this.$refs.DataTable.refresh();
        this.$root.$bvToast.toast('Vzorek úspěšně odeslán', {
          title: 'Úspěch',
          variant: 'success',
          toaster: 'b-toaster-top-right'
        });
        Promise.resolve(response);
      }).catch((err) => {
        this.$root.$bvToast.toast('Nepodařilo se odeslat do analýzy', {
          title: 'Nepodařilo se odeslat',
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
        Promise.reject(err);
      });
    },
  }
};
</script>
<style scoped></style>
